import { call, put, takeEvery } from 'redux-saga/effects';
import { createCategoryAPI, deleteCategoryAPI, getCategoryAPI, updateCategoryAPI } from "../Services"
import { ADD_CATEGORY, ADD_CATEGORY_RED, DELETE_CATEGORY, DELETE_CATEGORY_RED, GET_CATEGORY, GET_CATEGORY_RED, UPDATE_CATEGORY, UPDATE_CATEGORY_RED } from "../Constant"

// / Create Notifaction Saga
function* createCategorySaga(action) {
    try {
        const response = yield call(createCategoryAPI, action.payload);
        if (response && response.data) {
            yield put({ type: ADD_CATEGORY_RED, data: response.data });
        } else {
            console.error("Create Category API returned invalid data:", response);
        }
    } catch (error) {
        console.error("Error in createCategorySaga:", error);
    }
}

// Get Notifaction Saga
function* getCategorySaga() {
    try {
        const response = yield call(getCategoryAPI);
        if (response && response.data) {
            yield put({ type: GET_CATEGORY_RED, data: response.data });
        } else {
            console.error("Get Category API returned invalid data:", response);
        }
    } catch (error) {
        console.error("Error in getCategorySaga:", error);
    }
}

// Delete Notifaction Saga
function* deleteCategorySaga(action) {
    try {
        const response = yield call(deleteCategoryAPI, action.payload);
        if (response) {
            yield put({ type: DELETE_CATEGORY_RED, data: action.payload });
        } else {
            console.error("Delete Category API returned invalid data:", response);
        }
    } catch (error) {
        console.error("Error in deleteCategorySaga:", error);
    }
}

// Update Notifaction Saga
function* updateCategorySaga(action) {
    try {
        const response = yield call(updateCategoryAPI, action.payload);
        if (response) {
            yield put({ type: UPDATE_CATEGORY_RED, data: action.payload });
        } else {
            console.error("Update Category API returned invalid data:", response);
        }
    } catch (error) {
        console.error("Error in updateCategorySaga:", error);
    }
}

// Notifaction Saga (Watcher)
export function* categorySaga() {
    yield takeEvery(ADD_CATEGORY, createCategorySaga);
    yield takeEvery(GET_CATEGORY, getCategorySaga);
    yield takeEvery(DELETE_CATEGORY, deleteCategorySaga);
    yield takeEvery(UPDATE_CATEGORY, updateCategorySaga);
}
